export default __webpack_public_path__ + "static/media/faqs-icon.d4b0969c.svg";